export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    window.gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      personalization_storage: "granted",
      security_storage: "granted",
      functionality_storage: "granted",
    });
  }

  const jq = document.createElement("script");
  jq.src = "https://code.jquery.com/jquery-2.2.4.min.js";
  jq.crossOrigin = "anonymous";
  document.head.appendChild(jq);
};

export const onInitialClientRender = () => {
  // Inject CSS
  const style = document.createElement("link");
  style.rel = "stylesheet";
  style.href = "/CookieNoticePro/cookienoticepro.style.css";
  document.head.appendChild(style);

  // Inject Cookie Script AFTER jQuery loads
  const script = document.createElement("script");
  script.src = "/CookieNoticePro/cookienoticepro.script.js";
  script.onload = () => {
    if (window.cookieNoticePro) {
      window.cookieNoticePro.init();
      console.log("🍪 Cookie Notice Pro initialized");
    } else {
      console.warn("CookieNoticePro not found!");
    }
  };
  document.body.appendChild(script);
};

if (typeof window !== "undefined") {
  window.injectScripts = function () {
    if (!window.cookieNoticePro) return;

    if (window.cookieNoticePro.isPreferenceAccepted("analytics")) {
      console.log("Analytics enabled");
    }

    if (window.cookieNoticePro.isPreferenceAccepted("marketing")) {
      console.log("Marketing enabled");

      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_personalization: "granted",
        ad_user_data: "granted",
        analytics_storage: "granted",
      });
    }

    // Functional cookies
    if (window.cookieNoticePro.isPreferenceAccepted("preferences")) {
      console.log("⚙ Functional cookies enabled");
    }
  };
}
